export default "__VITE_ASSET__gDHn7rcD__"